import request from '../utils/request';
const querystring = require('querystring') 
//获取列表数据
export const fetchData = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'rootConfig/getData.do',
        method: 'post',
        params: query
    }); 
    return list;
};

//编辑
export const updateData = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'rootConfig/update.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

export const goNav = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    query.stationId = localStorage.getItem('ms_stationId');
    var list = request({
        url: 'haoka/rootConfig/get.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

export const setConfig = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    query.stationId = localStorage.getItem('ms_stationId');
    var list = request({
        url: 'haoka/rootConfig/setConfig.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};


 
 




